import React from 'react';

import constants from '../../utils/constants';

const KabbageFeatures = () => {
  const {
    KabbageCard,
    KabbageSimple,
    sites: { us },
  } = constants;

  return (
    <>
      <section className="med-hi dark-blue fits-1">
        <div className="container">
          <h2 className="h1-style">
            Small business loans that fit your business
          </h2>
          <div className="image" />
        </div>
      </section>
      <section className="med-hi fits-2">
        <div className="dots" />
        <div className="macbook" />
        <div className="container">
          <div className="three-column">
            <div className="column">
              <div className="two-column">
                <div className="column title">
                  <div className="image image-1" />
                </div>
                <div className="column">
                  <h5>Flexible Funds</h5>
                </div>
              </div>
              <div className="text">
                You decide when to use your funds and how much to take. As long
                as you have available funds, you can withdraw every time you
                need capital.
              </div>
            </div>
            <div className="column">
              <div className="two-column">
                <div className="column title">
                  <div className="image image-2" />
                </div>
                <div className="column">
                  <h5>Transparent Terms</h5>
                </div>
              </div>
              <div className="text">
                Kabbage Funding has simple, monthly payments with no origination
                fees or prepayment penalties. You can review your payment
                schedule before taking a loan so there won&#39;t be any
                surprises.
              </div>
            </div>
            <div className="column">
              <div className="two-column">
                <div className="column title">
                  <div className="image image-3" />
                </div>
                <div className="column">
                  <h5>Simple Process</h5>
                </div>
              </div>
              <div className="text">
                Securely link your business information online to get an
                automatic financial review. This lets us evaluate your business
                right away without requiring you to track down financial
                statements.
              </div>
            </div>
          </div>

          <div className="three-column">
            <div className="column">
              <div className="two-column">
                <div className="column title">
                  <div className="image image-4" />
                </div>
                <div className="column">
                  <h5>Convenient Access</h5>
                </div>
              </div>
              <div className="text">
                Withdraw from your line by logging into your computer, using our
                mobile app or swiping your <KabbageCard />. You&#39;ll have the
                security of a line of credit you can use whenever you need it,
                wherever you are.
              </div>
            </div>
            <div className="column">
              <div className="two-column">
                <div className="column title">
                  <div className="image image-5" />
                </div>
                <div className="column">
                  <h5>Trusted by Thousands</h5>
                </div>
              </div>
              <div className="text">
                <KabbageSimple /> customers have securely connected more than 1
                million data sources. We’re A+ rated by the Better Business
                Bureau and certified for our commitment to customer privacy.
              </div>
            </div>
            <div className="column">
              <div className="two-column">
                <div className="column title">
                  <div className="image image-6" />
                </div>
                <div className="column">
                  <h5>Personal Service</h5>
                </div>
              </div>
              <div className="text">
                From applying to managing your account and making the most of
                your capital, our in-house team of experts is here to help when
                you need it.
              </div>
            </div>
          </div>
          <div className="row">
            <a
              href={`https://${us}/learn-more/why-kabbage/`}
              className="pill-button green medium"
            >
              Why <span>You&#39;ll Love </span>
              Kabbage Funding
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default KabbageFeatures;
